/* eslint-disable spire/export-styles */
import { getCookie } from "@insite/client-framework/Common/Cookies";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { setMainNavigation } from "@insite/client-framework/Components/ShellHoleConnect";
import { NavigationModeCookieName } from "@insite/content-library/Components/NavigationModeMenu";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import GridContainer from "@insite/mobius/GridContainer";
import GridItem, { GridWidths } from "@insite/mobius/GridItem";
import ChevronDown from "@insite/mobius/Icons/ChevronDown";
import Link, { StyledIcon } from "@insite/mobius/Link";
import Menu from "@insite/mobius/Menu";
import Popover from "@insite/mobius/Popover";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import ChevronLeft from "@sunSource/Icons/ChevronLeft";
import ChevronRight from "@sunSource/Icons/ChevronRight";
import { MainNavigationStyles, MappedLink } from "@sunSource/Overrides/Widgets/Header/MainNavigation";
import * as React from "react";
import { css, ThemeProps, withTheme } from "styled-components";

interface OwnProps {
    link: MappedLink;
    index: number;
    styles: MainNavigationStyles;
    container: React.RefObject<HTMLElement | null>;
    isOpen: boolean;
    displayChangeCustomerLink: boolean;
}
export interface OrderLinesListStyles {
    morelink?: InjectableCss;
    subcategories?: InjectableCss;
}

export const orderLinesListStyles: OrderLinesListStyles = {
    subcategories: {
        css: css`
            .link {
                span {
                    font-size: 13px !important;
                    font-weight: normal;
                    color: rgb(3, 110, 183) !important;
                }
                a:hover {
                    span {
                        text-decoration: underline;
                    }
                }
            }
        `,
    },
};
interface State {
    hover: boolean;
}

type Props = ThemeProps<BaseTheme> & OwnProps;

class MainNavigationItem extends React.Component<Props, State> {
    element = React.createRef<HTMLElement>();
    popover = React.createRef<HTMLUListElement>();

    constructor(Props: ThemeProps<BaseTheme> & OwnProps) {
        super(Props);

        this.state = {
            hover: false,
        };
    }

    componentDidUpdate(prevProps: Readonly<Props>) {
        if (this.props.isOpen && !prevProps.isOpen) {
            this.openPopover();
        } else if (!this.props.isOpen && prevProps.isOpen) {
            this.closePopover();
        }
    }

    closePopover = () => {
        this.popover.current && (this.popover.current! as any).closePopover();
    };

    openPopover = () => {
        this.popover.current && (this.popover.current! as any).openPopover();
    };

    hoverOn = () => {
        this.setState({ hover: true });
    };

    hoverOff = () => {
        this.setState({ hover: false });
    };

    render() {
        const {
            styles,
            link,
            index,
            isOpen,
            theme: {
                breakpoints: { maxWidths },
            },
        } = this.props;
        const downIcon = <StyledIcon src={ChevronDown} {...styles.menuItemIcon} />;
        const hasChildren = link.children && link.children.filter(child => !child.excludeFromNavigation).length > 0;
        const isCascading =
            hasChildren && (link.childrenType === "CascadingMenu" || link.childrenType === "CustomLinkList");
        const isMega = hasChildren && link.childrenType === "MegaMenu";

        let menuLink = (
            <Link
                className="menu-item"
                typographyProps={styles.menuItemTypography}
                color={styles.menuItemTypography?.color}
                {...styles.menuItem}
                href={link.url}
                target={link.openInNewWindow ? "_blank" : ""}
            >
                {link.title}
                {isCascading && downIcon}
            </Link>
        );
        if (isMega || link.url === "") {
            menuLink = (
                <Link
                    className="menu-item"
                    typographyProps={styles.menuItemTypography}
                    color={styles.menuItemTypography?.color}
                    {...styles.menuItem}
                >
                    {link.title}
                    {(isCascading || isMega) && downIcon}
                </Link>
            );
        }

        let menuItem = menuLink;
        const menuLinkCas = (
            <Link
                typographyProps={styles.menuItemTypography}
                color={styles.menuItemTypography?.color}
                {...styles.menuItem}
                href=""
                target={link.openInNewWindow ? "_blank" : ""}
            >
                {link.title}
                {isCascading && downIcon}
            </Link>
        );

        if (isCascading && link.children) {
            const menuProps: { maxDepth?: number } = {};
            if (link.maxDepth) {
                menuProps.maxDepth = link.maxDepth;
            }
            menuItem = (
                <StyledWrapper onMouseOver={this.hoverOn} onMouseOut={this.hoverOff}>
                    <Link
                        typographyProps={styles.menuItemTypography}
                        color={styles.menuItemTypography?.color}
                        {...styles.menuItem}
                        href={link.url}
                        onClick={this.hoverOff}
                    >
                        {link.title}
                        {(isCascading || link.children) && downIcon}
                    </Link>
                    <StyledWrapper
                        {...(this.state.hover ? { ...styles.openCascadingMenu } : { ...styles.closeCascadingMenu })}
                    >
                        <GridContainer
                            {...styles.megaMenuGridContainer}
                            offsetProps={{ ...styles.megaMenuGridContainer?.offsetProps, as: "ul" }}
                        >
                            {link
                                .children!.filter(child => !child.excludeFromNavigation)
                                .map((child, index) => (
                                    // eslint-disable-next-line react/no-array-index-key
                                    <GridItem
                                        // eslint-disable-next-line react/no-array-index-key
                                        key={index}
                                        {...styles.megaMenuGridItem}
                                        as="li"
                                    >
                                        <Link
                                            {...styles.megaMenuHeading}
                                            href={child.url}
                                            onClick={this.hoverOff}
                                            target={child.title === "Rockwell Configurator" ? "_blank" : ""}
                                        >
                                            {child.title}
                                        </Link>
                                        {child?.children && (
                                            <StyledWrapper className="subChildren" as="ul">
                                                {child!.children
                                                    .filter(child => !child.excludeFromNavigation)
                                                    .map((child, index) => (
                                                        // eslint-disable-next-line react/no-array-index-key
                                                        <GridItem
                                                            // eslint-disable-next-line react/no-array-index-key
                                                            key={index}
                                                            /* {...styles.megaMenuGridItem} */
                                                            as="li"
                                                        >
                                                            <Link
                                                                /* {...styles.megaMenuHeading} */
                                                                href={child.url}
                                                                onClick={this.hoverOff}
                                                                target={
                                                                    child.title === "Rockwell Configurator"
                                                                        ? "_blank"
                                                                        : ""
                                                                }
                                                            >
                                                                {child.title}
                                                            </Link>
                                                        </GridItem>
                                                    ))}
                                            </StyledWrapper>
                                        )}
                                    </GridItem>
                                ))}
                        </GridContainer>
                    </StyledWrapper>
                </StyledWrapper>
            );
        }
        if (isMega) {
            menuItem = (
                <StyledWrapper {...styles.megaMenuWrapper} onMouseOver={this.hoverOn} onMouseOut={this.hoverOff}>
                    <Link
                        typographyProps={styles.menuItemTypography}
                        color={styles.menuItemTypography?.color}
                        {...styles.menuItem}
                        href={link.url}
                        onClick={this.hoverOff}
                    >
                        {link.title}
                        {(isCascading || isMega) && downIcon}
                    </Link>
                    <StyledWrapper
                        {...(this.state.hover ? { ...styles.openMegaMenu } : { ...styles.closeCascadingMenu })}
                    >
                        <GridContainer
                            {...styles.megaMenuGridContainer}
                            offsetProps={{ ...styles.megaMenuGridContainer?.offsetProps, as: "ul" }}
                        >
                            {link
                                .children!.filter(child => !child.excludeFromNavigation)
                                .map((child, index) => (
                                    // eslint-disable-next-line react/no-array-index-key
                                    <GridItem
                                        width={(12 / link.numberOfColumns!) as GridWidths}
                                        // eslint-disable-next-line react/no-array-index-key
                                        key={index}
                                        {...styles.megaMenuGridItem}
                                        as="li"
                                    >
                                        <Link {...styles.megaMenuHeading} href={child.url} onClick={this.hoverOff}>
                                            {child.title}
                                        </Link>
                                        {child.children && (
                                            <StyledWrapper
                                                {...orderLinesListStyles.subcategories}
                                                onClick={this.hoverOff}
                                            >
                                                <ul data-test-selector={`linksFor_${child.title}`}>
                                                    {child.children
                                                        .filter(grandChild => !grandChild.excludeFromNavigation)
                                                        .map(
                                                            (grandChild, index) =>
                                                                index < 6 && (
                                                                    // eslint-disable-next-line react/no-array-index-key
                                                                    <li key={index}>
                                                                        <Link
                                                                            {...styles.megaMenuLink}
                                                                            onClick={this.hoverOff}
                                                                            href={grandChild.url}
                                                                            data-test-selector={grandChild.title}
                                                                        >
                                                                            {grandChild.title}
                                                                        </Link>
                                                                    </li>
                                                                ),
                                                        )}
                                                    {child.children.length > 6 && (
                                                        <li className="link" {...orderLinesListStyles.morelink}>
                                                            <Link href={child.url} onClick={this.hoverOff}>
                                                                View All{" "}
                                                                <b>
                                                                    <ChevronRight />
                                                                </b>
                                                            </Link>
                                                        </li>
                                                    )}
                                                </ul>
                                            </StyledWrapper>
                                        )}
                                    </GridItem>
                                ))}
                        </GridContainer>
                    </StyledWrapper>
                </StyledWrapper>
            );
        }

        return menuItem;
    }
}

export default withTheme(MainNavigationItem);
